import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation, formatTranslation } from '@/lib/i18n';

const LanguageContext = createContext(null);

const STORAGE_KEY = 'leadflow_language';

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    // Check localStorage first
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && (stored === 'fr' || stored === 'en')) {
      return stored;
    }
    // Detect browser language
    const browserLang = navigator.language.split('-')[0];
    return browserLang === 'fr' ? 'fr' : 'en';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = (lang) => {
    if (lang === 'fr' || lang === 'en') {
      setLanguageState(lang);
    }
  };

  const toggleLanguage = () => {
    setLanguage(language === 'fr' ? 'en' : 'fr');
  };

  // t() function for translations
  const t = (key, params = {}) => {
    const text = getTranslation(language, key);
    return formatTranslation(text, params);
  };

  // Get all translations for current language
  const texts = translations[language];

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    texts,
    isFrench: language === 'fr',
    isEnglish: language === 'en',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
